import { Dialog, Transition } from "@headlessui/react";
import { AiOutlineClose } from "react-icons/ai";
import React, { Fragment, useState } from "react";
import styles from "./GuestEmailDialog.module.css";
import PhoneInput, { isValidPhoneNumber } from "react-phone-number-input";
import "react-phone-number-input/style.css";

const GuestEmailDialog = ({
  isOpen,
  onSubmit,
  onClose,
  handleContinueAsGuest,
}) => {
  const [email, setEmail] = useState("");
  const [first, setFirst] = useState("");
  const [last, setLast] = useState("");
  const [phone, setPhone] = useState("");

  const handleEmailChange = (event) => {
    setEmail(event.target.value);
  };
  const handleFirstChange = (event) => {
    setFirst(event.target.value);
  };
  const handleLastChange = (event) => {
    setLast(event.target.value);
  };
  // console.log(isOpen, onClose);
  const handleSubmit = () => {
    // console.log(email, first, last, phone);
    handleContinueAsGuest(email, first, last, phone);
    onSubmit(email, first, last, phone);
  };

  const handlePhoneChange = (value) => {
    setPhone(value);
    // console.log(value);
  };
  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog
        as="div"
        className={styles.dialog}
        open={true}
        onClose={() => onClose}
      >
        <Dialog.Overlay className={styles.overlay} />
        <div className={styles.box}>
          {/* <button className={styles.closeButton} onClick={() => onClose()}>
            <AiOutlineClose size={30} />
          </button> */}
          {/* <Dialog.Title>Please enter your email:</Dialog.Title> */}
          <input
            type="text"
            pattern="[A-Z0-9a-z._%+-]+@[A-Z0-9a-z.-]+\.[A-Za-z]{2,4}"
            value={email}
            style={{ color: "black" }}
            placeholder="Your Email Address"
            onChange={handleEmailChange}
          />{" "}
          {/* <Dialog.Title>Please enter your first Name:</Dialog.Title> */}
          <input
            type="text"
            pattern="[A-Za-z]"
            style={{ color: "black" }}
            value={first}
            placeholder="Your first Name"
            onChange={handleFirstChange}
          />{" "}
          {/* <Dialog.Title>Please enter your last name:</Dialog.Title> */}
          <input
            type="text"
            pattern="[A-Za-z]"
            value={last}
            style={{ color: "black" }}
            placeholder="Your last Name"
            onChange={handleLastChange}
          />
          <PhoneInput
            country={"us"}
            // value={formik.getFieldProps(name).value || ""}
            onChange={handlePhoneChange}
            value={phone}
            // onBlur={handlePhoneBlur}
            // inputStyle={{ width: "95%" }} // Set the input field width
            // containerStyle={{ width: "100%" }} // Set the container width
            // inputClass={styles["phone-input"]} // Apply custom styles
            placeholder="Phone Number"
            // buttonClass={styles["phone-flag"]}
          />
          <div className={styles.flex}>
            <button onClick={() => onClose()}>Close</button>
            <button onClick={handleSubmit}>Submit</button>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
};

export default GuestEmailDialog;
